import { AxiosPromise, AxiosStatic } from "axios";
import { Withdrawal } from "../types/Withdrawal";

export const findWithdrawalById =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (withdrawalId: string): AxiosPromise<Withdrawal> =>
    await appAxios.get(`${serverURL}/withdrawals/${withdrawalId}`, {
      withCredentials: true,
    });
